export default {
      id: "search-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite.svg#search",
      toString: function () {
        return this.url;
      }
    }